import styled from 'styled-components';
import Card from '@bexs/dollar/components/Card';

export const CardTable = styled(Card)`
  margin-bottom: 32px;
  ul {
    li {
      > div {
        word-break: break-all;
      }
    }
  }
`;
